/* One quiet sentence in the place of a failure: this states a fact about the person's access; it is not
   an alarm, and the reader has done nothing wrong. Tokens only (ADR-0007). */
.note {
  margin: 0;
  padding: 1px 0 1px 10px;
  border-left: 2px solid var(--line-2);
  color: var(--ink-2);
  font-size: var(--t-min);
  line-height: 1.55;
  max-width: 92ch;
}

.link {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}
